import ObstacleManager from "./game/ObstacleManager";

export default {
    /**
     * @static
     * @type {number}
     * @default 1792
     */
    STAGE_WIDTH: 1792,

    /**
     * @static
     * @type {number}
     * @default 768
     */
    STAGE_HEIGHT: 768,

    /**
     * @static
     * @type {object}
     */
    config: {},

    /**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.Renderer}
     */
    renderer: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    stage: null,

    /**
     * @static
     * @type {P3.Ticker}
     */
    ticker: null,

    /**
     * @static
     * @type {PIXI.Container}
     */
    transitions: null,

    /**
     * @static
     * @type {?object}
     */
    strings: null,

    /**
     * @static
     * @type {number}
     */
    ghostId: 1,

    /**
     * @static
     * @type {Array}
     */
    skins: [
        ObstacleManager.TYPE.PAINT,
        ObstacleManager.TYPE.SLIME,
        ObstacleManager.TYPE.SPIDER_FLOOR,
        ObstacleManager.TYPE.SPIDER_STRING_A,
        ObstacleManager.TYPE.SPIDER_STRING_B,
        ObstacleManager.TYPE.BATS
    ],

    /**
     * @static
     * @type {Array}
     */
    scoobySkins: [ObstacleManager.TYPE.PAINT],

    /**
     * @static
     * @type {Array}
     */
    shaggySkins: [ObstacleManager.TYPE.PAINT]
}